__turbopack_context__.v({
  "address": "BoutiqueListingCard-module-scss-module__9wfHCW__address",
  "addressLine": "BoutiqueListingCard-module-scss-module__9wfHCW__addressLine",
  "body": "BoutiqueListingCard-module-scss-module__9wfHCW__body",
  "card": "BoutiqueListingCard-module-scss-module__9wfHCW__card",
  "contact": "BoutiqueListingCard-module-scss-module__9wfHCW__contact",
  "contactLabel": "BoutiqueListingCard-module-scss-module__9wfHCW__contactLabel",
  "contactLine": "BoutiqueListingCard-module-scss-module__9wfHCW__contactLine",
  "contactValue": "BoutiqueListingCard-module-scss-module__9wfHCW__contactValue",
  "ctaButton": "BoutiqueListingCard-module-scss-module__9wfHCW__ctaButton",
  "hoursText": "BoutiqueListingCard-module-scss-module__9wfHCW__hoursText",
  "image": "BoutiqueListingCard-module-scss-module__9wfHCW__image",
  "imageLink": "BoutiqueListingCard-module-scss-module__9wfHCW__imageLink",
  "imagePlaceholder": "BoutiqueListingCard-module-scss-module__9wfHCW__imagePlaceholder",
  "imageWrapper": "BoutiqueListingCard-module-scss-module__9wfHCW__imageWrapper",
  "linkIcon": "BoutiqueListingCard-module-scss-module__9wfHCW__linkIcon",
  "links": "BoutiqueListingCard-module-scss-module__9wfHCW__links",
  "name": "BoutiqueListingCard-module-scss-module__9wfHCW__name",
  "statusDot": "BoutiqueListingCard-module-scss-module__9wfHCW__statusDot",
  "statusDot_closed": "BoutiqueListingCard-module-scss-module__9wfHCW__statusDot_closed",
  "statusDot_open": "BoutiqueListingCard-module-scss-module__9wfHCW__statusDot_open",
  "statusDot_temporary": "BoutiqueListingCard-module-scss-module__9wfHCW__statusDot_temporary",
  "statusLeft": "BoutiqueListingCard-module-scss-module__9wfHCW__statusLeft",
  "statusRow": "BoutiqueListingCard-module-scss-module__9wfHCW__statusRow",
  "statusText": "BoutiqueListingCard-module-scss-module__9wfHCW__statusText",
  "textLink": "BoutiqueListingCard-module-scss-module__9wfHCW__textLink",
});
